import {faTimes} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React, {useEffect, useState} from 'react'
import background from '../images/Group 118@2x.png'
import bookCover from '../images/book_cover.png'
import '../styles/email-modal.scss'

const EmailModal = (props) => {
    const [isVisible, makeHidden] = useState(true)

    const isBrowser = typeof window !== "undefined"

    function hideModal(e) {
        e.preventDefault()
        document.cookie = "showModal=false; Max-Age=86400"
        makeHidden(false)
    }

    function cookieExists(cookieName) {
        if (isBrowser) {
            let name = cookieName + "="
            let spli = document.cookie.split(';')
            for(let j = 0; j < spli.length; j++) {
                let char = spli[j]
                while (char.charAt(0) === ' ') {
                    char = char.substring(1)
                }
                if (char.indexOf(name) === 0) {
                    return true
                }
            }
            return false
        } else {
            return false
        }
    }

    useEffect( () => {
        const script = document.createElement('script')
        script.async = true
        script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'

        setTimeout(() => {
                let signup = document.querySelectorAll('.email-modal')
                if ( signup.length > 0 ) {
                    signup[0].classList.add('modal-takeover')
                }
        }, 15000)
    }, [])

    if (isVisible && !cookieExists('showModal')) {
    return (
        <section className="email-signup email-modal">
            <a href="#" id="modal-close" className="modal__close" onClick={hideModal}>
                <FontAwesomeIcon icon={faTimes} size="2x"/>
            </a>
            <div className="email-signup__inner" style={{ backgroundImage: `url('${background}')` }}>
                <div className="email-signup__inner__content">
                    <div className="book-container">
                        <div className="book">
                            <img src={bookCover} alt="Habits for Spiritual Growth"/>
                        </div>
                    </div>
                    <h4>Free ebook: <em>Habits for Spiritual Growth</em></h4>
                </div>
                <p>Sign up for our weekly email and get a free download</p>
                <div id="email-modal">
                    <div id="mc_embed_signup">
                        <form
                            action="https://bibletolife.us21.list-manage.com/subscribe/post?u=86dc365188714eaf189d870dc&amp;id=5844b095ce&amp;f_id=00cec5e1f0"
                            method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"
                            className="validate" target="_blank" noValidate>
                            <div className="ao-row" id="mc_embed_signup_scroll">
                                <div className="mc-field-group">
                                    <input type="email" name="EMAIL" className="required email"
                                           id="mce-EMAIL" placeholder="Email*" required/>
                                    <span id="mce-EMAIL-HELPERTEXT" className="helper_text"/>
                                </div>
                                <div id="mce-responses" className="clear">
                                    <div className="response" id="mce-error-response"/>
                                    <div className="response" id="mce-success-response"/>
                                </div>
                                <div className="address-field" aria-hidden="true"><input
                                    type="text" name="b_86dc365188714eaf189d870dc_5844b095ce" tabIndex="-1"/></div>
                                <div className="clear"><input type="submit" value="Subscribe" name="subscribe"
                                                              id="mc-embedded-subscribe" className="button"/></div>
                                                              <input type="hidden" name="tags" value="2821422"/>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
    } else {
        return null
    }
}

export default EmailModal
